import { useEffect } from 'react'
import { useOS } from './useOS'

export const SaveKey = 's'

export const useSaveEventListener = (callback: VoidFunction) => {
  const { os } = useOS()

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (
        (os === 'mac' && event.metaKey && event.key === SaveKey) ||
        ((os === 'windows' || os === 'linux') &&
          event.ctrlKey &&
          event.key === SaveKey)
      ) {
        event.preventDefault()
        callback()
      }
    }

    window.addEventListener('keydown', handleKeydown)

    return () => {
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [os, callback])
}
